import { SortType } from "../SortType";

/** Entity shape for admin categories + fields returned by `/v1/categories`. */
export interface Category {
  id: number;
  name: string;
  priority: number;
  display: boolean;
  active: boolean;
  desc?: string | null;
  seo_title?: string | null;
  seo_description?: string | null;
  creator_name?: string | null;
  created_date?: string | null;
  modifier_name?: string | null;
  modified_date?: string | null;
  parent_id?: number | null;
  parent_name?: string | null;
  category_image_url?: string | null;
}

export interface GetCategoriesParams {
  page_no: number;
  limit?: number;
  sort_by?: string;
  sort_type?: SortType;
  /** Text / substring search — backend query param `search` */
  search?: string;
  /** Omit = no filter; `true` = active only; `false` = inactive only */
  active?: boolean;
}

export interface CategoryUpsertPayload {
  name: string;
  priority?: number;
  display?: boolean;
  active?: boolean;
  desc?: string;
  seo_title?: string;
  seo_description?: string;
}

const SORT_BY_FIELDS = ["id", "name", "priority", "active", "display"] as const;
export type CategoryListSortBy = (typeof SORT_BY_FIELDS)[number];

export const CATEGORY_SORT_BY_OPTIONS: { value: CategoryListSortBy; label: string }[] =
  [
    { value: "id", label: "ID" },
    { value: "name", label: "Name" },
    { value: "priority", label: "Priority" },
    { value: "display", label: "Display" },
    { value: "active", label: "Active" },
  ];

export function normalizeCategoryListSortBy(
  raw: string | null | undefined,
): CategoryListSortBy {
  if (raw && (SORT_BY_FIELDS as readonly string[]).includes(raw)) {
    return raw as CategoryListSortBy;
  }
  return "name";
}
